import React, { useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import ToggleButtons from "../../components/ToggleButtons";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import { setMealType, setLocation } from "../../Redux/reportSlice";
import moment from "moment";
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import dayjs from "dayjs";

const ReportFilter = ({
  name,
  handleButtonClick,
  onClick,
  tempStartDate,
  tempEndDate,
  setTempStartDate,
  setTempEndDate,
  btnText = "Export",
  searchUser,
  handleSearchUser,
}) => {
  const dispatch = useDispatch();

  // Select Redux state
  const { mealType, location, startDate, endDate } = useSelector(
    (state) => state.report
  );

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMealTypeChange = (e) => {
    dispatch(setMealType(e.target.value));
  };

  const handleLocationChange = (e) => {
    dispatch(setLocation(e.target.value));
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const currentMonth = dayjs();

  const formattedMonth = moment(currentMonth.$d).format("MMM YYYY");
  const formatedInvoiceMonth = moment(currentMonth.$d)
    .subtract(1, "month")
    .format("MMM YYYY");

  return (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="h6" mb={2} fontWeight="bold" flexBasis={"20%"}>
        {name}
      </Typography>

      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        gap={2}
        mb={2}
        flexBasis={"80%"}
      >
        {name.includes("Meal Details") && (
          <Box sx={{ maxWidth: "450px", width: "100%" }}>
            <TextField
              placeholder="Search user"
              size="small"
              fullWidth
              value={searchUser}
              onChange={handleSearchUser}
            />
          </Box>
        )}
        <Box display="flex" gap={2}>
          <TextField
            size="small"
            sx={{ width: "170px" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VolunteerActivismOutlinedIcon />
                </InputAdornment>
              ),
            }}
            select
            value={mealType}
            variant="outlined"
            onChange={handleMealTypeChange}
          >
            <MenuItem value={1}>Breakfast</MenuItem>
            <MenuItem value={2}>Dinner</MenuItem>
          </TextField>

          <TextField
            size="small"
            sx={{ width: "170px" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <RoomOutlinedIcon />
                </InputAdornment>
              ),
            }}
            select
            value={location}
            variant="outlined"
            onChange={handleLocationChange}
          >
            <MenuItem value={1}>Mumbai</MenuItem>
            <MenuItem value={2}>Noida</MenuItem>
            <MenuItem value={3}>Mohali</MenuItem>
            <MenuItem value={4}>Hyderabad</MenuItem>
          </TextField>

          <Button
            variant="outlined"
            startIcon={
              btnText === "Download" ? (
                <PictureAsPdfIcon />
              ) : (
                <IosShareOutlinedIcon />
              )
            }
            sx={{
              borderColor: "#C1C1C2",
              color: "black",
              "&:hover": { borderColor: "#C1C1C2", color: "black" },
            }}
            onClick={onClick}
          >
            {btnText}
          </Button>

          {(name?.includes("Report") || name === "Invoice") && (
            <>
              <Button
                variant={startDate && endDate ? "contained" : "outlined"}
                onClick={handleOpenMenu} // Open menu on click
                startIcon={<DateRangeOutlinedIcon />}
                endIcon={<ArrowDropDownIcon fontSize="large" />}
                sx={{
                  borderColor: !startDate && !endDate && "#C1C1C2",
                  color: !startDate && !endDate && "black",
                  "&:hover": {
                    borderColor: !startDate && !endDate && "#C1C1C2",
                    color: !startDate && !endDate && "black",
                  },
                }}
              >
                {startDate && endDate
                  ? moment(startDate.$d).format("MMM YYYY")
                  : name === "Invoice"
                  ? formatedInvoiceMonth
                  : formattedMonth}
              </Button>

              {/* Custom Date Picker Dropdown */}
              <CustomDateRangePicker
                name={name}
                setTempStartDate={setTempStartDate}
                setTempEndDate={setTempEndDate}
                anchorEl={anchorEl}
                handleClose={handleCloseMenu}
              />
            </>
          )}
        </Box>

        {name?.includes("Report") && (
          <ToggleButtons
            setTempStartDate={setTempStartDate}
            setTempEndDate={setTempEndDate}
          />
        )}
      </Box>
    </Box>
  );
};

export default ReportFilter;
